import i18n from "@/plugins/i18n";
import Index from "@/views/Index";

const teacherRoutes = [
    {
        path: "/",
        name: "TeacherArea",
        component: () => import("../layout/MainLayout"),
        children: [
            /* Dashboard */
            {
                path: "/dashboard",
                name: "Dashboard",
                component: () => import("@/views/teacher/dashboard/TeacherDashboard"),
                meta: {name: "Teacher Dashboard"},
            },

            /* Teacher */
            {
                path: "/teachers", component: Index, children: [
                    {
                        path: "list",
                        name: "TeachersList",
                        component: () => import("../views/teacher/teacher/ListTeacher"),
                        meta: {name: i18n.t("List of teachers")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditTeacher",
                        component: () => import("../views/teacher/teacher/EditTeacher"),
                        meta: {name: i18n.t("Edit teacher"), menuShow: "TeachersList"},
                    },
                    {
                        path: "add",
                        name: "AddTeacher",
                        component: () => import("../views/teacher/teacher/AddTeacher"),
                        meta: {name: i18n.t("Add a new teacher"), menuShow: "TeachersList"},
                    },
                    {
                        path: "logs",
                        name: "TeacherLogs",
                        component: () => import("../views/teacher/teacherLogs/ListTeacherLog"),
                        meta: {name: i18n.t("list of teachers log")},
                    },

                ]
            },

            /* RightGroup */
            {
                path: "/rightGroup/list",
                name: "RightGroup",
                component: () => import("../views/teacher/rightGroup/ListRightGroup"),
                meta: {name: i18n.t("List of rightGroups")},
            },

            /* Student */
            {
                path: "/registerUser", component: Index, children: [
                    {
                        path: "list",
                        name: "RegisteredUserList",
                        component: () => import("../views/teacher/registeredUser/ListRegisteredUser"),
                        meta: {name: i18n.t("List of students")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditRegisteredUser",
                        component: () => import("../views/teacher/registeredUser/EditRegisteredUser"),
                        meta: {name: i18n.t("Edit student"), menuShow: "RegisteredUserList"},
                    },
                    {
                        path: "add",
                        name: "AddRegisteredUser",
                        component: () => import("../views/teacher/registeredUser/AddRegisteredUser"),
                        meta: {name: i18n.t("Add a new student"), menuShow: "RegisteredUserList"},
                    },
                    {
                      path: "logs",
                      name: "StudentLogs",
                      component: () => import("../views/teacher/studentLogs/ListStudentLog"),
                      meta: {name: i18n.t("List of student logs")},
                    }
                ]
            },

            /* Retail student */
            {
                path: "/retailStudent", component: Index, children: [
                    {
                        path: "list",
                        name: "RetailStudentList",
                        component: () => import("../views/teacher/retailStudent/ListRetailStudent"),
                        meta: {name: i18n.t("Join the lecture")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditRetailStudent",
                        component: () => import("../views/teacher/retailStudent/EditRetailStudent"),
                        meta: {name: i18n.t("Edit students to join the lecture"), menuShow: "RetailStudentList"},
                    },
                    {
                        path: "add",
                        name: "AddRetailStudent",
                        component: () => import("../views/teacher/retailStudent/AddRetailStudent"),
                        meta: {name: i18n.t("Add students to join the lecture"), menuShow: "RetailStudentList"},
                    },
                ]
            },

            /* Student Note record */
            {
                path: "/registeredUserNoteRecord", component: Index, children: [
                    {
                        path: "list/:id",
                        name: "ListRegisteredUserNoteRecord",
                        component: () => import("../views/teacher/registeredUserNoteRecord/ListRegisteredUserNoteRecord"),
                        meta: {name: i18n.t("Note record"), menuShow: "RegisteredUserList"}
                    },
                ]
            },

            /* Student score record */
            {
                path: "/registeredUserScoreRecord", component: Index, children: [
                    {
                        path: "list/:id",
                        name: "ListRegisteredUserScoreRecord",
                        component: () => import("../views/teacher/registeredUserScoreRecord/ListRegisteredUserScoreRecord"),
                        meta: {name: i18n.t("Score record"), menuShow: "RegisteredUserList"}
                    },
                ]
            },

            /* Study */
            {
                path: "/study", component: Index, children: [
                    {
                        path: "list/:id?/:name?/:idCourse?",
                        name: "StudyList",
                        component: () => import("../views/teacher/study/Study.vue"),
                        meta: {name: i18n.t("Learning progress")},
                    },
                ]
            },

            /* UserGroup */
            {
                path: "/userGroup", component: Index, children: [
                    {
                        path: "list",
                        name: "UserGroupList",
                        component: () => import("../views/teacher/userGroup/ListUserGroup"),
                        meta: {name: i18n.t("List of user groups")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditUserGroup",
                        component: () => import("../views/teacher/userGroup/EditUserGroup"),
                        meta: {name: i18n.t("Edit user group"), menuShow: "UserGroupList"},
                    },
                    {
                        path: "add",
                        name: "AddUserGroup",
                        component: () => import("../views/teacher/userGroup/AddUserGroup"),
                        meta: {name: i18n.t("Add a new user group"), menuShow: "UserGroupList"},
                    },
                ]
            },

            /* UserGroup score record */
            {
                path: "/userGroupScoreRecord", component: Index, children: [
                    {
                        path: "list/:id",
                        name: "UserGroupScoreRecordList",
                        component: () => import("../views/teacher/userGroupScoreRecord/ListUserGroupScoreRecord"),
                        meta: {name: i18n.t("Score record"), menuShow: "UserGroupList"}
                    }
                ]
            },

            /* UserGroup note record */
            {
                path: "/userGroupNoteRecord", component: Index, children: [
                    {
                        path: "list/:id",
                        name: "UserGroupNoteRecordList",
                        component: () => import("../views/teacher/userGroupNoteRecord/ListUserGroupNoteRecord"),
                        meta: {name: i18n.t("Note record"), menuShow: "UserGroupList"}
                    },
                ]
            },

            /* Course */
            {
                path: "/course", component: Index, children: [
                    {
                        path: "list",
                        name: "CoursesList",
                        component: () => import("../views/teacher/course/ListCourse"),
                        meta: {name: i18n.t("List of courses")}
                    },
                    {
                        path: "edit/:id",
                        name: "EditCourse",
                        component: () => import("../views/teacher/course/EditCourse"),
                        meta: {name: i18n.t("Edit course"), menuShow: "CoursesList"},
                    },
                    {
                        path: "add",
                        name: "AddCourse",
                        component: () => import("../views/teacher/course/AddCourse"),
                        meta: {name: i18n.t("Add a new course"), menuShow: "CoursesList"},
                    },
                ]
            },

            /* Course review*/
            {
                path: "/courseReviewAndComment/:idCourse?",
                component: Index,
                children: [
                    {
                        path: "list",
                        name: "CourseReviewList",
                        component: () => import("../views/teacher/courseReviewAndComment/ListCourseReviewAndComment"),
                        meta: {name: i18n.t("Course review")}
                    },
                ]
            },

            /* Course category*/
            {
                path: "/courseCategory",
                component: Index,
                children: [
                    {
                        path: "list",
                        name: "CourseCategoriesList",
                        component: () => import("../views/teacher/courseCategory/ListCategory"),
                        meta: {name: i18n.t("Course category")}
                    },
                ]
            },

            /* Course package*/
            {
                path: "/course-package", component: Index, children: [
                    {
                        path: "list",
                        name: "CoursePackageList",
                        component: () => import("../views/teacher/coursePackage/ListCoursePackage"),
                        meta: {name: i18n.t("List of course packages")}
                    },
                    {
                        path: "edit/:id",
                        name: "EditCoursePackage",
                        component: () => import("../views/teacher/coursePackage/EditCoursePackage"),
                        meta: {name: i18n.t("Edit course package"), menuShow: "CoursePackageList"},
                    },
                    {
                        path: "add",
                        name: "AddCoursePackage",
                        component: () => import("../views/teacher/coursePackage/AddCoursePackage"),
                        meta: {name: i18n.t("Add a new course package"), menuShow: "CoursePackageList"},
                    },
                ]
            },

            /* Setting */
            {
                path: "/setting",
                component: Index,
                children: [
                    {
                        path: "certificate",
                        name: "CertificateSetting",
                        component: () => import("../views/teacher/settings/certificate/CertificateSetting"),
                        meta: {name: i18n.t("Certificate setting")}
                    },
                    {
                        path: "domain",
                        name: "DomainSecuritySetting",
                        component: () => import("../views/teacher/settings/domain/DomainSetting"),
                        meta: {name: i18n.t("Domain security setting")}
                    },
                    {
                        path: "package-service",
                        name: "PackageServiceSetting",
                        component: () => import("../views/teacher/settings/packageService/PackageServiceSetting"),
                        meta: {name: i18n.t("Package service setting")}
                    },
                    {
                        path: "marketing-tools",
                        name: "MarketingToolSetting",
                        component: () => import("../views/teacher/settings/marketingTool/MarketingToolSetting"),
                        meta: {name: i18n.t("Marketing tool setting")}
                    },
                    // {
                    //     path: "notification",
                    //     name: "NotificationSettingList",
                    //     component: () => import("../views/teacher/settings/notification/tabs/AddNotification/ListNotificationSetting.vue"),
                    //     meta: {name: i18n.t("Notification setting"), menuShow: "NotificationSettingList"}
                    // },
                    {
                        path: "notification",
                        component: Index,
                        children: [
                            {
                                path: "",
                                name: "NotificationSettingList",
                                component: () => import("../views/teacher/settings/notification/Notification.vue"),
                                meta: {name: i18n.t("Notification setting"), menuShow: "NotificationSettingList"},
                            },
                            {
                                path: "addNotification",
                                name: "NotificationSettingAdd",
                                component: () => import("../views/teacher/settings/notification/tabs/AddNotification/AddNotificationSetting.vue"),
                                meta: {name: i18n.t("Add a new notification"), menuShow: "NotificationSettingList"}
                            },
                            {
                                path: "editNotification/:id",
                                name: "NotificationSettingEdit",
                                component: () => import("../views/teacher/settings/notification/tabs/AddNotification/EditNotificationSetting.vue"),
                                meta: {name: i18n.t("Edit notification"), menuShow: "NotificationSettingList"}
                            },
                        ]
                    },
                    {
                        path: "information",
                        name: "InformationSetting",
                        component: () => import("../views/teacher/settings/information/InformationSetting"),
                        meta: {name: i18n.t("Information setting")}
                    },
                    {
                        path: "subject",
                        name: "SubjectSetting",
                        component: () => import("../views/teacher/settings/subject/ListSubjectSetting"),
                        meta: {name: i18n.t("Subject")}
                    },
                    {
                        path: "transcript",
                        name: "TranscriptSetting",
                        component: () => import("../views/teacher/settings/transcript/ListTranscriptSetting"),
                        meta: {name: i18n.t("Transcript")}
                    },
                    {
                        path: "classLevel",
                        name: "ClassLevelSetting",
                        component: () => import("../views/teacher/settings/classLevel/ClassLevelSetting"),
                        meta: {name: i18n.t("Class level setting")}
                    },
                    {
                        path: "landingPage",
                        name: "LandingPageSetting",
                        component: () => import("../views/teacher/landingPage/LandingPageList"),
                        meta: {name: i18n.t("Landing Page")}
                    },
                    {
                        path: "design/:id",
                        name: "DesignPageSetting",
                        component: () => import("../views/teacher/design/DesignPage"),
                        meta: {name: i18n.t("Design landing page")}
                    },
                    {
                        path: "design-2/:id",
                        name: "DesignPageSetting2",
                        component: () => import("../views/teacher/design/DesignPage2"),
                        meta: {name: i18n.t("Design user manual page")}
                    },
                    {
                        path: "design-3/:id",
                        name: "DesignPageSetting3",
                        component: () => import("../views/teacher/design/DesignPage3"),
                        meta: {name: i18n.t("Design privacy page")}
                    },
                    {
                        path: "design-4/:id",
                        name: "DesignPageSetting4",
                        component: () => import("../views/teacher/design/DesignPage4"),
                        meta: {name: i18n.t("Design page")}
                    },
                    {
                        path: "mailTemplate",
                        name: "MailTemplateSetting",
                        component: () => import("../views/teacher/settings/mailTemplate/MailTemplateSetting"),
                        meta: {name: i18n.t("Mail template")}
                    },
                    {
                        path: "securitySetting",
                        name: "SecuritySetting",
                        component: () => import("../views/teacher/settings/security/SecuritySetting"),
                        meta: {name: i18n.t("Security setting")}
                    },
                    {
                        path: "paymentSetting",
                        name: "PaymentSetting",
                        component: () => import("../views/teacher/settings/payment/PaymentSetting"),
                        meta: {name: i18n.t("Payment setting")}
                    },
                    {
                        path: "department",
                        name: "DepartmentList",
                        component: () => import("../views/teacher/settings/department/ListDepartmentSetting"),
                        meta: {name: i18n.t("Major"), menuShow: "DepartmentList"}
                    },
                    {
                        path: "semester",
                        name: "SemesterList",
                        component: () => import("../views/teacher/settings/semesters/SemesterList.vue"),
                        meta: {name: i18n.t("Khai báo năm học"), menuShow: "SemesterList"}
                    },
                    {
                        path: "siteApproveSetting",
                        name: "SiteApproveSetting",
                        component: () => import("../views/teacher/settings/siteApprove/SiteApproveSetting"),
                        meta: {name: i18n.t("Approve setting")}
                    },
                    {
                        path: "siteAuthenticateSetting",
                        name: "SiteAuthenticateSetting",
                        component: () => import("../views/teacher/settings/authenticateSetting/SiteAuthenticateSetting"),
                        meta: {name: i18n.t("Login setting")}
                    },
                    {
                        path: "mailSetting",
                        name: "MailSetting",
                        component: () => import("../views/teacher/settings/mailSetting/MailSetting"),
                        meta: {name: i18n.t("Mail setting")}
                    }
                ]
            },

            /* Teaching */
            {
                path: "/teaching", component: Index, children: [
                    {
                        path: "list",
                        name: "TeachingList",
                        component: () => import("../views/teacher/teaching/ListTeaching"),
                        meta: {name: i18n.t("Teaching"), menuShow: "TeachingList"}
                    },
                    {
                        path: "edit/:id",
                        name: "EditTeaching",
                        component: () => import("../views/teacher/teaching/EditTeaching"),
                        meta: {name: i18n.t("Teaching"), menuShow: "TeachingList"}
                    },
                    {
                        path: "add",
                        name: "AddTeaching",
                        component: () => import("../views/teacher/teaching/AddTeaching"),
                        meta: {name: i18n.t("Teaching"), menuShow: "TeachingList"}
                    },
                ]
            },

            /* Monitor */
            {
                path: "/monitor", component: Index, children: [
                    {
                        path: "list",
                        name: "MonitorList",
                        component: () => import("../views/teacher/monitor/ListMonitor"),
                        meta: {name: i18n.t("List of monitors"), menuShow: "MonitorList"}
                    },
                    {
                        path: "edit/:id",
                        name: "EditMonitor",
                        component: () => import("../views/teacher/monitor/EditMonitor"),
                        meta: {name: i18n.t("Edit monitor"), menuShow: "MonitorList"}
                    },
                    {
                        path: "add",
                        name: "AddMonitor",
                        component: () => import("../views/teacher/monitor/AddMonitor"),
                        meta: {name: i18n.t("Add a new monitor"), menuShow: "MonitorList"}
                    },
                ]
            },

            /* Profile */
            {
                path: "/user", component: Index, children: [
                    {
                        path: "profile",
                        name: "Profile",
                        component: () => import("../views/teacher/profile/Profile"),
                        meta: {name: i18n.t("Profile"), menuShow: "Dashboard"}
                    }
                ]
            },

            /* fileCategory*/
            {
                path: "/fileCategory", component: Index, children: [
                    {
                        path: "list",
                        name: "FileCategoryList",
                        component: () => import("../views/teacher/fileCategory/ListFileCategory"),
                        meta: {name: i18n.t("File category"), menuShow: "FileCategoryList"}
                    },
                ]
            },

            /* post */
            {
                path: "/post", component: Index, children: [
                    {
                        path: "list",
                        name: "PostList",
                        component: () => import("../views/teacher/post/ListPost"),
                        meta: {name: i18n.t("list of post"), menuShow: "PostList"}
                    },
                    {
                        path: "add",
                        name: "PostAdd",
                        component: () => import("../views/teacher/post/AddPost"),
                        meta: {name: i18n.t("Add a new post"), menuShow: "PostList"}
                    },
                    {
                        path: "edit/:id",
                        name: "PostEdit",
                        component: () => import("../views/teacher/post/EditPost"),
                        meta: {name: i18n.t("Edit post"), menuShow: "PostList"}
                    },
                ]
            },

            /* post category */
            {
                path: "/postCategory", component: Index, children: [
                    {
                        path: "list",
                        name: "PostCategoryList",
                        component: () => import("../views/teacher/postCategory/ListPostCategory"),
                        meta: {name: i18n.t("Post category"), menuShow: "PostCategoryList"}
                    },
                ]
            },

            /* File */
            {
                path: "/file", component: Index, children: [
                    {
                        path: "list",
                        name: "FileList",
                        component: () => import("../views/teacher/file/FileList"),
                        meta: {name: i18n.t("File")}
                    }
                ]
            },

            /* Active code */
            {
                path: "/activeCode", component: Index, children: [
                    {
                        path: "list",
                        name: "ActiveCodeList",
                        component: () => import("../views/teacher/activeCode/ListActiveCode"),
                        meta: {name: i18n.t("Active code"), menuShow: "ActiveCodeList"}
                    },
                    {
                        path: "add",
                        name: "ActiveCodeAdd",
                        component: () => import("../views/teacher/activeCode/AddActiveCode"),
                        meta: {name: i18n.t("Add a new active code"), menuShow: "ActiveCodeList"}
                    },
                    {
                        path: "edit/:id",
                        name: "ActiveCodeEdit",
                        component: () => import("../views/teacher/activeCode/EditActiveCode"),
                        meta: {name: i18n.t("Edit active code"), menuShow: "ActiveCodeList"}
                    },
                ]
            },

            /* Coupon code */
            {
                path: "/couponCode", component: Index, children: [
                    {
                        path: "list",
                        name: "CouponCodeList",
                        component: () => import("../views/teacher/couponCode/ListCouponCode"),
                        meta: {name: i18n.t("Coupon code"), menuShow: "CouponCodeList"}
                    },
                    {
                        path: "add",
                        name: "CouponCodeAdd",
                        component: () => import("../views/teacher/couponCode/AddCouponCode"),
                        meta: {name: i18n.t("Add a new coupon code"), menuShow: "CouponCodeList"}
                    },
                    {
                        path: "edit/:id",
                        name: "CouponCodeEdit",
                        component: () => import("../views/teacher/couponCode/EditCouponCode"),
                        meta: {name: i18n.t("Edit coupon code"), menuShow: "CouponCodeList"}
                    }
                ]
            },

            /* Order */
            {
                path: "/order", component: Index, children: [
                    {
                        path: "list",
                        name: "OrderList",
                        component: () => import("../views/teacher/order/ListOrder"),
                        meta: {name: i18n.t("List of orders"), menuShow: "OrderList"}
                    },
                    {
                        path: "add",
                        name: "OrderAdd",
                        component: () => import("../views/teacher/order/AddOrder"),
                        meta: {name: i18n.t("Add a new order"), menuShow: "OrderList"}
                    },
                    {
                        path: "edit/:id",
                        name: "EditOrder",
                        component: () => import("../views/teacher/order/EditOrder"),
                        meta: {name: i18n.t("Edit order"), menuShow: "OrderList"}
                    },
                ]
            },
            /* quizTest */
            {
                path: "/exam", component: Index, children: [
                    {
                        path: "list/:examId?",
                        name: "Exam",
                        component: () => import("../views/teacher/exam/Exam"),
                        meta: {name: i18n.t("Exam-Test"), menuShow: "Exam"}
                    }
                ]
            },
            /* Schedule */
            {
                path: "/schedule", component: Index, children: [
                    {
                        path: "list",
                        name: "ScheduleList",
                        component: () => import("../views/teacher/schedule/ListSchedule"),
                        meta: {name: i18n.t("Teacher schedule"), menuShow: "ScheduleList"}
                    }
                ]
            },
            /* Revenue Report */
            {
                path: "/revenueReport", component: Index, children: [
                    {
                        path: "list",
                        name: "RevenueReportList",
                        component: () => import("../views/teacher/revenueReport/ListReportMooc.vue"),
                        meta: {name: i18n.t("Revenue report")}
                    }
                ]
            },

            /* Mooc Partner */
            {
                path: "/moocPartner", component: Index, children: [
                    {
                        path: "list",
                        name: "MoocPartnerList",
                        component: () => import("../views/teacher/moocPartner/ListMoocPartner.vue"),
                        meta: {name: i18n.t("List of partners")},
                    },
                    {
                        path: "list-cp",
                        name: "CpPartnerList",
                        component: () => import("../views/teacher/moocPartner/ListCpPartner.vue"),
                        meta: {name: i18n.t("Affiliates sell courses")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditMoocPartner",
                        component: () => import("../views/teacher/moocPartner/EditMoocPartner.vue"),
                        meta: {name: i18n.t("Edit partner"), menuShow: "MoocPartnerList"},
                    },
                    {
                        path: "add",
                        name: "AddMoocPartner",
                        component: () => import("../views/teacher/moocPartner/AddMoocPartner.vue"),
                        meta: {name: i18n.t("Add a new partner"), menuShow: "MoocPartnerList"},
                    },
                ]
            },

            /*Mooc Approve*/
            {
                path: "/moocApprove", component: Index, children: [
                    {
                        path: "setting",
                        name: "MoocApproveSetting",
                        component: () => import("../views/teacher/moocApprove/Setting.vue"),
                        meta: {name: i18n.t("Approving the course")},
                    },
                    {
                        path: "list-cp",
                        name: "CpApproveCourseList",
                        component: () => import("../views/teacher/moocApprove/ListCp.vue"),
                        meta: {name: i18n.t("List of courses sent for approval")},
                    },
                    {
                        path: "list-mooc",
                        name: "MoocApproveCourseList",
                        component: () => import("../views/teacher/moocApprove/ListMooc.vue"),
                        meta: {name: i18n.t("List of courses sent by units")},
                    },
                    {
                        path: "detail-mooc/:id",
                        name: "MoocApproveCourseDetail",
                        component: () => import("../views/teacher/moocApprove/DetailMooc.vue"),
                        meta: {name: i18n.t("List of courses sent by units"), menuShow: "MoocApproveCourseList"},
                    },
                    {
                        path: "approveLogs-mooc/:courseName/:id",
                        name: "MoocApproveCourseLogs",
                        component: () => import("../views/teacher/moocApprove/ApproveLogs.vue"),
                        meta: {name: i18n.t("Course approval history"), menuShow: "MoocApproveCourseList"},
                    },

                ],

            },
            /*Mooc Approve Flow*/
            {
                path: "/moocApproveFlow", component: Index, children: [
                    {
                        path: "list",
                        name: "MoocApproveFlowList",
                        component: () => import("../views/teacher/moocApproveFlow/ListMoocApproveFlow.vue"),
                        meta: {name: i18n.t("List of approve flow")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditMoocApproveFlow",
                        component: () => import("../views/teacher/moocApproveFlow/EditMoocApproveFlow.vue"),
                        meta: {name: i18n.t("Edit approve flow")},
                    },
                    {
                        path: "add",
                        name: "AddMoocApproveFlow",
                        component: () => import("../views/teacher/moocApproveFlow/AddMoocApproveFlow.vue"),
                        meta: {name: i18n.t("Add a new approve flow")},
                    },
                ]
            },

            /*Mooc Approve Logs*/
            {
                path: "/moocApproveLog", component: Index, children: [
                    {
                        path: "list",
                        name: "MoocApproveLogList",
                        component: () => import("../views/teacher/moocApproveLogs/ListMoocApproveLogs.vue"),
                        meta: {name: i18n.t("List of approve log")},
                    },
                ]
            },
            /* Tag*/
            {
                path: "/tag",
                component: Index,
                children: [
                    {
                        path: "list",
                        name: "TagList",
                        component: () => import("../views/teacher/tag/ListTag.vue"),
                        meta: {name: i18n.t("List of tags")}
                    },
                ]
            },

            /*Course Setting*/
            {
                path: "/courseSetting", component: Index, children: [
                    /*Course Approve*/
                    {
                        path: "courseApprove", component: Index, children: [
                            {
                                path: "list",
                                name: "CourseApproveList",
                                component: () => import("../views/teacher/courseApprove/ListMooc.vue"),
                                meta: {name: i18n.t("List of courses waiting to be sold on MOOC")},
                            },
                            {
                                path: "setting-mooc/:id",
                                name: "MoocCourseSetting",
                                component: () => import("../views/teacher/courseApprove/SettingMooc.vue"),
                                meta: {name: i18n.t("Setting the course on MOOC"), menuShow: "CourseApproveList"},
                            },
                        ],
                    },
                    /*Selling Course*/
                    {
                        path: "sellingCourse", component: Index, children: [
                            {
                                path: "list",
                                name: "SellingCourseList",
                                component: () => import("../views/teacher/sellingCourse/ListSellingCourse.vue"),
                                meta: {name: i18n.t("List of courses on sale on MOOC")},
                            },
                        ],
                    },
                    /*Eject Course*/
                    {
                        path: "ejectCourse", component: Index, children: [
                            {
                                path: "list",
                                name: "EjectCourseList",
                                component: () => import("../views/teacher/ejectCourse/ListEjectCourse.vue"),
                                meta: {name: i18n.t("List of eject courses")},
                            },
                        ],
                    }
                ]
            },
            /*Mooc Payment setting*/
            {
                path: "moocPaymentSetting", component: Index, children: [
                    {
                        path: "list",
                        name: "MoocPaymentSetting",
                        component: () => import("../views/teacher/moocPaymentSetting/MoocPaymentSetting.vue"),
                        meta: {name: i18n.t("Payment setting")},
                    },
                ],
            },

            /*Mooc Partner Revenue Report*/
            {
                path: "partnerRevenue", component: Index, children: [
                    {
                        path: "",
                        name: "PartnerReportList",
                        component: () => import("../views/teacher/partnerRevenue/PartnerRevenue.vue"),
                        meta: {name: i18n.t("Affiliate unit")},
                    },
                    {
                        path: "payment-detail/:id",
                        name: "PartnerReportPaymentInfo",
                        component: () => import("../views/teacher/partnerRevenue/tabs/revenueTab/PaymentInfo.vue"),
                        meta: {name: i18n.t("Billing information"), menuShow: "PartnerReportList"},
                    },

                ],
            },

            /*CP Course Report*/
            {
                path: "course-report", component: Index, children: [
                    {
                        path: "list",
                        name: "CpCourseReportList",
                        component: () => import("../views/teacher/courseReport/ListCP.vue"),
                        meta: {name: i18n.t("Statistics of courses listed for sale on MOOCs")},
                    },
                    {
                        path: "detail/:id",
                        name: "CpCourseReportDetail",
                        component: () => import("../views/teacher/courseReport/ListDetail.vue"),
                        meta: {name: i18n.t("Course details"), menuShow: "CpCourseReportList"},
                    },

                ],
            },

            /*Cp Payment setting*/
            {
                path: "cpPaymentSetting", component: Index, children: [
                    {
                        path: "",
                        name: "CpPaymentSetting",
                        component: () => import("../views/teacher/cpPaymentSetting/PaymentSettingCp.vue"),
                        meta: {name: i18n.t("Payment setting")},
                    },
                ],
            },

            /*Cp Revenue report*/
            {
                path: "revenue-report", component: Index, children: [
                    {
                        path: "order",
                        name: "CpRevenueReportList",
                        component: () => import("../views/teacher/revenueReport/cp/order/ListOrder.vue"),
                        meta: {name: i18n.t("Order")},
                    },
                    {
                        path: "history",
                        name: "CpRevenueReportPaymentHistory",
                        component: () => import("../views/teacher/revenueReport/cp/paymentHistory/ListPaymentHistory.vue"),
                        meta: {name: i18n.t("Payment history"), menuShow: "CpRevenueReportList"},
                    },
                    {
                        path: "income",
                        name: "CpRevenueReportIncome",
                        component: () => import("../views/teacher/revenueReport/cp/income/ListIncome.vue"),
                        meta: {name: i18n.t("Income"), menuShow: "CpRevenueReportList"},
                    },

                ],
            },

            /* Dashboard MOOC*/
            {
                path: "dashboard-mooc",
                name: "MoocDashboard",
                component: () => import("../views/teacher/dashboard/mooc/DashboardMooc.vue"),
                meta: {name: i18n.t("Dashboard")},
            },

            /* Cooperation Sign Up*/
            {
                path: "cooperation-signup", component: Index, children: [
                    {
                        path: "list",
                        name: "CooperationSignUpList",
                        component: () => import("../views/teacher/cooperationSignUp/ListCooperationSignUp.vue"),
                        meta: {name: i18n.t("List of cooperation information")},
                    },
                    {
                        path: "add",
                        name: "AddCooperationSignUp",
                        component: () => import("../views/teacher/cooperationSignUp/AddCooperationSignUp.vue"),
                        meta: {name: i18n.t("Add new cooperation information")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditCooperationSignUp",
                        component: () => import("../views/teacher/cooperationSignUp/EditCooperationSignUp.vue"),
                        meta: {name: i18n.t("Edit cooperation information")},
                    },
                ]
            },

            {
                path: "/myNotification", component: Index, children: [
                    {
                        path: "list",
                        name: "MyNotification",
                        component: () => import("../views/teacher/notification/MyNotification"),
                        meta: {name: i18n.t("Notification")}
                    },
                    {
                        path: "detail/:id",
                        name: "NotificationDetail",
                        component: () => import("../views/teacher/notification/NotificationDetail"),
                        meta: {name: i18n.t("Notification")}
                    }
                ]
            },

            /* Affiliate */
            {
                path: "affiliate", component: Index, children: [
                    /* member */
                    {
                        path: "",
                        name: "AffiliateList",
                        component: () => import("../views/teacher/affiliate/member/ListAffiliate.vue"),
                        meta: {name: i18n.t("Members list")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditAffiliate",
                        component: () => import("../views/teacher/affiliate/member/EditAffiliate.vue"),
                        meta: {name: i18n.t("Members list"), menuShow: "AffiliateList"},
                    },

                    {
                        path: "surplus",
                        name: "AffiliateSurplusList",
                        component: () => import("../views/teacher/affiliate/surplus/Surplus.vue"),
                        meta: {name: i18n.t("Surplus")},
                    },
                    {
                        path: "payment",
                        name: "AffiliatePaymentList",
                        component: () => import("../views/teacher/affiliate/payment/Payment.vue"),
                        meta: {name: i18n.t("Payment")},
                    },
                    /* revenue */
                    {
                        path: "revenue",
                        name: "AffiliateRevenueList",
                        component: () => import("../views/teacher/affiliate/revenue/Revenue.vue"),
                        meta: {name: i18n.t("Revenue")},
                    },
                    {
                        path: "revenue/payment/:id",
                        name: "AffiliateRevenuePaymentInfo",
                        component: () => import("../views/teacher/affiliate/revenue/PaymentInfo.vue"),
                        meta: {name: i18n.t("Payment info"), menuShow: "AffiliateRevenueList"},
                    },

                    {
                        path: "discount",
                        name: "AffiliateDiscountSetting",
                        component: () => import("../views/teacher/affiliate/discount/Discount.vue"),
                        meta: {name: i18n.t("Discount settings")},
                    },
                ],
            },
            {
                path: "moocLandingPageSetting",
                name: "MoocLandingPageSetting",
                component: () => import("../views/teacher/moocLandingPageSetting/LandingPageSetting.vue"),
                meta: {name: i18n.t("Landing page setting")},
            },

            {
                path: "/my-course", component: Index, children: [
                    {
                        path: "list",
                        name: "MyCourseList",
                        component: () => import("../views/student/course/ListCourse"),
                        meta: {name: i18n.t("My course")},
                    },
                    {
                        path: ":id",
                        name: "CourseDetail",
                        component: () => import("../views/student/course/CourseDetail"),
                        meta: {name: i18n.t("Detail course")},
                    },
                ],
            },

            /* lesson */
            {
                path: "/course/:id/lesson/:idLesson?",
                name: "LessonDetail",
                component: () => import("../views/student/lesson/LessonDetail"),
                meta: {name: i18n.t("Video lesson")}
            },

            /* TeacherGroup */
            {
                path: "/teacherGroup", component: Index, children: [
                    {
                        path: "list",
                        name: "TeachersGroupList",
                        component: () => import("../views/teacher/teacherGroup/ListTeacherGroup"),
                        meta: {name: i18n.t("List of teacher groups")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditTeacherGroup",
                        component: () => import("../views/teacher/teacherGroup/EditTeacherGroup"),
                        meta: {name: i18n.t("Edit teacher group"), menuShow: "TeachersGroupList"},
                    },
                    {
                        path: "add",
                        name: "AddTeacherGroup",
                        component: () => import("../views/teacher/teacherGroup/AddTeacherGroup"),
                        meta: {name: i18n.t("Add a new teacher group"), menuShow: "TeachersGroupList"},
                    },
                ]
            },

            /* Unit Management */
            {
                path: "/unit-management", component: Index, children: [
                    {
                        path: "list",
                        name: "UnitManagementList",
                        component: () => import("../views/teacher/unitManagement/ListUnitManagement.vue"),
                        meta: {name: i18n.t("List of units")}
                    },
                    {
                        path: "add",
                        name: "AddUnitManagement",
                        component: () => import("../views/teacher/unitManagement/AddUnitManagement.vue"),
                        meta: {name: i18n.t("Add a new unit"), menuShow: "UnitManagementList"}
                    },
                    {
                        path: "edit/:id",
                        name: "EditUnitManagement",
                        component: () => import("../views/teacher/unitManagement/EditUnitManagement.vue"),
                        meta: {name: i18n.t("Edit unit"), menuShow: "UnitManagementList"}
                    }
                ]
            },

            /* UserGroup */
            {
                path: "/k12class", component: Index, children: [
                    {
                        path: "list",
                        name: "ClassList",
                        component: () => import("../views/teacher/class/ListClass"),
                        meta: {name: i18n.t("List of class")},
                    },
                    {
                        path: "edit/:id",
                        name: "EditClass",
                        component: () => import("../views/teacher/class/EditClass"),
                        meta: {name: i18n.t("Edit class"), menuShow: "ClassList"},
                    },
                    {
                        path: "add",
                        name: "AddClass",
                        component: () => import("../views/teacher/class/AddClass"),
                        meta: {name: i18n.t("Add a new class"), menuShow: "ClassList"},
                    },
                ]
            },
        ]
    }
]

export default teacherRoutes;
